import { useEffect } from 'react';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { SavedAddressWidgetDashboard } from '@/features/consumer/saved-address-widget-dashboard';
import { UpcomingCleaningWidgetDashboard } from '@/features/consumer/upcoming-cleaning-widget-dashboard';
import { LatestBookingWidgetDashboard } from '@/features/consumer/latest-booking-widget-dashboard';
import { useTrack } from '@/features/tracking/useTrack';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(consumer)/_authenticated/dashboard')({
  component: DashboardPage,
});

export function DashboardPage() {
  const track = useTrack();

  useEffect(() => {
    track('impression', {
      eventAction: 'impression',
      eventCategory: 'homepage',
      eventDescription: 'visitHomepage',
      eventLabel: 'homepage',
    });
  }, [track]);

  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.Title>Dashboard</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <div>
          <SavedAddressWidgetDashboard />
        </div>
        <div>
          <UpcomingCleaningWidgetDashboard />
        </div>
        <div>
          <LatestBookingWidgetDashboard />
        </div>
      </div>
    </div>
  );
}
